// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__22Ma9","local":"Banner_local__14shb","dev":"Banner_dev__OMhtB","test":"Banner_test__27lkt"};